'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import WildsLaunchContainer from '../WildsLaunchContainer';
import ParallaxText from '@components/ParallaxText';
import { ImageObj } from '@custom-types/ImageObj.types';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';
interface WildsLaunchWelcomeProps {
  t: any;
  welcomeBgImage: ImageObj;
  WelcomeBottomShape: ImageObj;
}
export default function WildsLaunchWelcome(props: WildsLaunchWelcomeProps) {
  const { t } = props;
  return (
    <Box component="section" className={cn.wildsWelcome}>
      <Box className={cn.wildsWelcomeBackground}>
        <Image
          src={props.welcomeBgImage.url}
          alt="Wilds Launch Welcome - Welcome Bg Image"
          width={768}
          height={768}
        />
      </Box>
      <Stack className={cn.wildsWelcomeInner}>
        <WildsLaunchContainer>
          <Box className={cn.wildsWelcomeBlock}>
            <Box className={cn.wildsWelcomeBlock__header}>
              <ParallaxText
                variant="h2"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(t['welcomeHeading'])}
              </ParallaxText>
            </Box>
            <Box className={cn.wildsWelcomeBlock__content}>
              <ParallaxText
                variant="p"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(t['welcomeDesc'])}
              </ParallaxText>
            </Box>
          </Box>
        </WildsLaunchContainer>
      </Stack>
      <Box
        className={cn.wildsBottomShape}
        sx={{
          backgroundImage: `url(${props.WelcomeBottomShape.url})`,
          minWidth: {
            xs: '65%',
            sm: '62%',
            md: '60%',
            lg: '50%',
          },
          maxWidth: {
            xs: '65%',
            sm: '62%',
            md: '60%',
            lg: '50%',
          },
        }}
      />
    </Box>
  );
}
